module.exports = __webpack_public_path__ + "fonts/fa-solid-900.e68a62d2.woff";